import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import { fetchFeedEventPending, getEventPendingFeed } from 'mewe/fetchers/fetch-feed';
import { isDefined } from 'mewe/utils/miscellaneous-utils';

export let AppEventFeedPendingRouteBase = {
  theme: Theme.EVENT,

  model(params, transition) {
    const eventId = this.paramsFor('app.event').event_id;

    fetchFeedEventPending(eventId);

    return {
      eventId: eventId,
      eventState: this.modelFor('app.event').eventState,
      feed: getEventPendingFeed(eventId),
      app: this.modelFor('app'),
      isPendingFeed: true,
      preventScroll: this.shouldPreventPageScroll(transition),
    };
  },

  // don't scroll feed when transition from all posts feed, feed types were switched
  shouldPreventPageScroll(transition) {
    const pendingFeedRoute = 'app.event.feed-pending';
    return (
      isDefined(transition.router.oldState && transition.router.oldState.params[pendingFeedRoute]) ||
      this.routeName === pendingFeedRoute
    );
  },

  actions: {
    refetchFeed() {
      fetchFeedEventPending(this.currentModel.eventId);
    },
  },
};

export default Route.extend(AppEventFeedPendingRouteBase);
